var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 22.5H38.3333C38.5543 22.5 38.7663 22.5878 38.9227 22.744C39.0788 22.9003 39.1667 23.1123 39.1667 23.3333V38.3333C39.1667 38.5543 39.0788 38.7663 38.9227 38.9227C38.7663 39.0788 38.5543 39.1667 38.3333 39.1667H27.5V22.5Z",
    fill: "#E3E3E3",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 18.333C27.5 16.3439 26.7098 14.4362 25.3033 13.0297C23.8968 11.6232 21.9892 10.833 20 10.833C18.0108 10.833 16.1032 11.6232 14.6967 13.0297C13.2902 14.4362 12.5 16.3439 12.5 18.333V39.1663H27.5V18.333Z",
    fill: "#E3E3E3",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 39.1667H1.66634C1.44533 39.1667 1.23337 39.0788 1.07709 38.9227C0.920804 38.7663 0.833008 38.5543 0.833008 38.3333V23.3333C0.833008 23.1123 0.920804 22.9003 1.07709 22.744C1.23337 22.5878 1.44533 22.5 1.66634 22.5H12.4997V39.1667Z",
    fill: "#E3E3E3",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9997 25.833H31.6663C31.2062 25.833 30.833 26.2062 30.833 26.6663V28.333C30.833 28.7932 31.2062 29.1663 31.6663 29.1663H34.9997C35.4598 29.1663 35.833 28.7932 35.833 28.333V26.6663C35.833 26.2062 35.4598 25.833 34.9997 25.833Z",
    fill: "#66E1FF",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.833 35.8333H30.833V33.3333C30.833 33.1123 30.9208 32.9003 31.077 32.744C31.2333 32.5878 31.4453 32.5 31.6663 32.5H34.9997C35.2207 32.5 35.4327 32.5878 35.589 32.744C35.7452 32.9003 35.833 33.1123 35.833 33.3333V35.8333Z",
    fill: "#66E1FF",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 25.833H5.00033C4.54009 25.833 4.16699 26.2062 4.16699 26.6663V28.333C4.16699 28.7932 4.54009 29.1663 5.00033 29.1663H8.33366C8.79389 29.1663 9.16699 28.7932 9.16699 28.333V26.6663C9.16699 26.2062 8.79389 25.833 8.33366 25.833Z",
    fill: "#66E1FF",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 32.5H5.00033C4.54009 32.5 4.16699 32.8732 4.16699 33.3333V35C4.16699 35.4602 4.54009 35.8333 5.00033 35.8333H8.33366C8.79389 35.8333 9.16699 35.4602 9.16699 35V33.3333C9.16699 32.8732 8.79389 32.5 8.33366 32.5Z",
    fill: "#66E1FF",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 31.667C22.5 31.004 22.2367 30.368 21.7678 29.8992C21.299 29.4303 20.663 29.167 20 29.167C19.337 29.167 18.701 29.4303 18.2322 29.8992C17.7633 30.368 17.5 31.004 17.5 31.667V39.167H22.5V31.667Z",
    fill: "#FF808C",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 10.8797V5.83301",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 0.833008H25.8337C26.0547 0.833008 26.2667 0.920804 26.423 1.07709C26.5792 1.23337 26.667 1.44533 26.667 1.66634V4.99967C26.667 5.22069 26.5792 5.43266 26.423 5.58892C26.2667 5.74521 26.0547 5.83301 25.8337 5.83301H19.167V0.833008Z",
    fill: "#FF808C",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.833C21.3807 20.833 22.5 19.7137 22.5 18.333C22.5 16.9523 21.3807 15.833 20 15.833C18.6193 15.833 17.5 16.9523 17.5 18.333C17.5 19.7137 18.6193 20.833 20 20.833Z",
    fill: "#66E1FF",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.3e6eeabc24e2e5e7b15c07cf62197045.svg";
export { ForwardRef as ReactComponent };